import { Lookup } from '../lookup.interface';

export const LmtaActivityArchiveReasons: { [name: string]: Lookup } = {
  activeOnAish: {
    displayValue: 'Active on AISH',
    code: 'activeOnAish',
  },
  clientRequest: {
    displayValue: 'Client request',
    code: 'clientRequest',
  },
  deceased: {
    displayValue: 'Deceased',
    code: 'deceased',
  },
  duplicateFile: {
    displayValue: 'Duplicate file',
    code: 'duplicateFile',
  },
  excessIncomeResourcesEmployment: {
    displayValue: 'Excess income/resources including employment',
    code: 'excessIncomeResourcesEmployment',
  },
  excessIncomeResourcesNonEmployment: {
    displayValue: 'Excess income/resources non-employment',
    code: 'excessIncomeResourcesNonEmployment',
  },
  incarceration: {
    displayValue: 'Incarceration',
    code: 'incarceration',
  },
  leavingEmployment: {
    displayValue: 'Leaving employment that could have been reasonably maintained',
    code: 'leavingEmployment',
  },
  movingOutOfProvince: {
    displayValue: 'Moving out of province',
    code: 'movingOutOfProvince',
  },
  servicesComplete: {
    displayValue: 'Services Complete',
    code: 'servicesComplete',
  },
};
